/**
 * ImportCSV theme matching Product Radar's design system.
 * Uses colors from index.css (--primary, --gray-*, --background, etc.)
 */
export const importCsvTheme = {
  'font-family':
    'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  'font-size': '14px',
  'base-spacing': '1rem',
  'border-radius': '8px',
  'color-primary': '#245F73',
  'color-primary-hover': '#1a4a59',
  'color-secondary': '#245F73',
  'color-secondary-hover': '#1a4a59',
  'color-text': 'rgb(29, 29, 29)',
  'color-text-soft': '#5a5c5b',
  'color-text-on-primary': '#ffffff',
  'color-text-on-secondary': '#ffffff',
  'color-background': '#ffffff',
  'color-background-modal': 'var(--background)',
  'color-input-background': '#ffffff',
  'color-input-background-soft': 'var(--background)',
  'color-background-menu-hover': '#e8e6e5',
  'color-border': '#d4d2d1',
  'color-importer-link': '#245F73',
  'color-progress-bar': '#245F73',
} as const;
